<template>
  <div
    @touchmove="gtouchmove"
    v-bind:class="{ 'append-box': true, closeStyle: closeStyle }"
  >
    <loading-circle v-if="showCircle"></loading-circle>
    <template v-if="themeStatus == 'done'">
      <template v-if="theme == 'zhongqiu'">
        <img
          src="@/assets/img/theme/zhongqiu/UI_loading_H5BG_01.jpg"
          class="img-bg bg1"
        />
        <img
          src="@/assets/img/theme/zhongqiu/UI_loading_H5BG_02.jpg"
          class="img-bg bg2"
        />
      </template>
      <template v-if="theme == 'newYear2020'">
        <img
          src="@/assets/img/theme/new-year-2020/loading_new_year_2020.jpg"
          class="img-bg bg1"
        />
        <img
          src="@/assets/img/theme/new-year-2020/loading_new_year_2020_2.jpg"
          class="img-bg bg2"
        />
      </template>
      <template v-else>
        <template v-if="style == 1">
          <img src="@/assets/img/UI_loading_H5BG_01.jpg" class="img-bg bg1" />
          <img src="@/assets/img/UI_loading_H5BG_02.jpg" class="img-bg bg2" />
        </template>
        <template v-else>
          <img
            src="@/assets/style2/img/UI_loading_H5BG_01.jpg"
            class="img-bg bg1"
          />
          <img
            src="@/assets/style2/img/UI_loading_H5BG_02.jpg"
            class="img-bg bg2"
          />
        </template>
      </template>
    </template>
    <div class="abs-center-box container" ondragstart="return false;">
      <img
        :src="logoSource"
        v-bind:class="{ 'img-logo': style == 1, 'img-logo-style2': style != 1 }"
        :onerror="errorImg"
        v-if="logoSource"
      />
      <!-- <div
        v-bind:class="{
          'loading-txt-box': true,
          'loading-txt-box-style2': style != 1,
        }"
      >
        <span v-html="text" class="txt"></span>
        <div class="scaling-dots">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import store from "@/store/index";
import { Base64 } from "js-base64";
import loadingCircle from "./loadingCircle.vue";
import base64Img from "@/config/base64Img.js";
export default {
  name: "whiteLoading",
  data() {
    return {
      timer: null,
      showCircle: false,
      style: store.state.app.appInfo.style,
      text: "正在载入资源，请稍候",
      showLogo: true,
      closeStyle: false,
      logoSource: "",
      defaultLogo: require("@/assets/img/logo.png"),
      errorImg: "this.src=" + base64Img.logo + "",
      changeLang: undefined,
    };
  },
  computed: {
    theme() {
      return store.state.app.theme;
    },
    themeStatus() {
      return store.state.app.themeStatus;
    },
    logoType() {
      return store.state.app.appInfo.logo_type || 2;
    },
    logoUrl() {
      return store.state.app.appInfo.logo_url;
    },
    lang() {
      return store.state.app.lang;
    },
    baisonLogo() {
      if (store.state.app.appInfo.style == 1) {
        return require("@/assets/img/platform_logo.png");
      } else {
        return require("@/assets/style2/img/style2_platform_logo.png");
      }
    },
    baisonEnLogo() {
      if (store.state.app.appInfo.style == 1) {
        return require("@/assets/img/platform_en_logo.png");
      } else {
        return require("@/assets/style2/img/style2_platform_logo_en.png");
      }
    },
  },
  mounted() {
    if (this.logoType == 1) {
      if (this.logoUrl) {
        try {
          const customUrl = Base64.decode(this.logoUrl);
          this.logoSource = customUrl;
        } catch {
          this.logoSource = this.defaultLogo;
        }
      } else {
        this.logoSource = this.defaultLogo;
      }
    } else {
      if (this.changeLang) {
        if (this.changeLang == "cn") {
          this.logoSource = this.baisonLogo;
        } else {
          this.logoSource = this.baisonEnLogo;
        }
      } else {
        if (this.lang == "cn") {
          this.logoSource = this.baisonLogo;
        } else {
          this.logoSource = this.baisonEnLogo;
        }
      }
    }
    this.timer = window.setTimeout(() => {
      this.showCircle = true;
      window.clearTimeout(this.timer);
    }, 3 * 1000);
  },
  components: {
    loadingCircle,
  },
  methods: {
    gtouchmove(e) {
      e.preventDefault();
      e.stopPropagation();
    },
    close() {
      //   this.closeStyle = true;
      //   this.$nextTick(() => {
      //     window.setTimeout(() => {
      //       this.remove();
      //     }, 500);
      //   });
      this.remove();
    },
    remove() {
      if (this.timer) {
        window.clearTimeout(this.timer);
        this.timer = null;
      }
      this.$el.parentNode && this.$el.parentNode.removeChild(this.$el);
      this.$destroy(true);
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes hide {
  0% {
    opacity: 1;
    display: block;
  }
  100% {
    opacity: 0;
    display: none;
  }
}
.closeStyle {
  -webkit-animation: hide 0.5s linear forwards;
  animation: hide 0.5s linear forwards;
}
.append-box {
  .bg2 {
    display: none;
  }
  z-index: 9999;
  .img-bg {
    width: 100%;
    height: 100%;
  }
  .img-logo {
    width: 1.98rem;
  }
  .img-logo-style2 {
    width: 2.2rem;
  }
  .loading-txt-box {
    display: table;
    margin: 0.4rem auto;
    .txt {
      font-size: 0.14rem;
      padding-right: 0.05rem;
      display: table-cell;
      //   color: #2a4057;
      color: #ffffff;
    }
    .scaling-dots {
      div {
        background: #ffffff;
        // background: #2a4057;
      }
    }
  }
  .loading-txt-box-style2 {
    .txt {
      color: #6e4d31;
    }
    .scaling-dots {
      div {
        background: #6e4d31;
        // background: #2a4057;
      }
    }
  }
}
@media all and (orientation: portrait) {
  .append-box {
    .bg1 {
      display: none;
    }
    .bg2 {
      display: block;
    }
    .container {
      transform: translate(-50%, -50%) rotate(90deg);
    }
  }
}
</style>